import * as React from 'react';
import * as elog from '@reverbdotcom/commons/dist/elog';
import ErrorDisplay from './discovery/error_display';
import { WithRouterProps } from 'react-router';

interface IProps {
  name?: string;
}

interface IState {
  hasError: boolean;
}

// This component can should be used at the top of most routes
// to provide an actionable error screen (broken guitar) for
// our users instead of a blank render.
export default class RouteErrorBoundary extends React.Component<Partial<WithRouterProps> & IProps, IState> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const { location, params, name } = this.props;

    const err = new Error(`Fatal React Error: ${error.message}`);
    err.stack = error.stack;

    elog.error('fatal-routing-error', { location, params, name }, err);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorDisplay />;
    }

    return this.props.children;
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/route_error_boundary.tsx